// SEO优化模块路由配置
export const seoMain = [
  {
    name: 'seo',
    path: '/seo',
    meta: {
      title: 'SEO优化',
      icon: 'search'
    }
  },
  {
    name: 'seoConfig',
    path: '/seo/config',
    component: () => import('../../../views/plugins/seo/SeoConfig.vue'),
    meta: {
      title: 'SEO配置',
      icon: 'setting',
      plugin: 'seo',
      keepAlive: true
    }
  },
  {
    name: 'seoLinkSubmit',
    path: '/seo/submit',
    component: () => import('../../../views/plugins/seo/LinkSubmit.vue'),
    meta: {
      title: '链接提交',
      icon: 'link',
      plugin: 'seo'
    }
  },
  {
    name: 'seoAnalysis',
    path: '/seo/analysis',
    component: () => import('../../../views/plugins/seo/SeoAnalysis.vue'),
    meta: {
      title: 'SEO分析',
      icon: 'data-analysis',
      plugin: 'seo'
    }
  },
  {
    name: 'seoSitemap',
    path: '/seo/sitemap',
    component: () => import('../../../views/plugins/seo/Sitemap.vue'),
    meta: {
      title: '站点地图',
      icon: 'map-location',
      plugin: 'seo'
    }
  },
  {
    name: 'seoSettings',
    path: '/seo/settings',
    component: () => import('../../../views/plugins/seo/SeoSettings.vue'),
    meta: {
      title: 'SEO设置',
      icon: 'tools',
      plugin: 'seo'
    }
  }
]

export default seoMain
